var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.1 106.1",
    style: {
      enableBackground: "new 0 0 106.1 106.1"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#116EC1}\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Forward") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M0.9,35.7c16.3,6.5,32.5,13,48.8,19.5c0.5,0.2,0.9,0.5,1.1,1.1c5.9,14.9,11.9,29.7,17.8,44.6c0.7,1.7,1.3,3.3,2.1,5.2 L106.1,0L0,35.4L0.9,35.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowOn);
export default __webpack_public_path__ + "static/media/follow-on.8bde7807cdc0f52f8487982ecea0fec9.svg";
export { ForwardRef as ReactComponent };